<template>
  <div class="notdetail-body">
    <div class="fixed-title" :style="scrollopacityStyle">
      <div class="top-title">
        <span class="back-btn-img"
          ><img :src="backicon" alt="" @click="goback"
        /></span>
        <div class="top-search-div">
        </div>
      </div>
    </div>
    <div class="supermark-datail-info-div">
      <div class="supermarket-img">
        <img :src="merchantinfo.logo" alt="" />
      </div>
      <div class="supermarket-info">
        <div class="supermarket-name">
          {{ merchantinfo.shop_name | loadingStatus(merchantinfo.shop_name) }}
        </div>
        <div v-if="merchantinfo.intro" style="position:relative;">
            <div class="supermarket-remark">描述：{{merchantinfo.intro}}</div>
              <div v-if="merchantinfo.intro&&merchantinfo.intro.length>=15" class="supermarket-fold" @click="foldshow=true">
                  <img :src="foldshow?foldtop:foldbottom" />
              </div>
          </div>
        <div class="supermarket-address">
          <span class="time-icon"><img :src="blacktimeicon" alt="" /></span>
          <span class="supermarket-address-text">
            营业时间：<span v-show="merchantinfo.business_hours_start"
              >{{
                merchantinfo.business_hours_start
                  | loadingStatus(merchantinfo.business_hours_start)
              }}～{{
                merchantinfo.business_hours_end
                  | loadingStatus(merchantinfo.business_hours_end)
              }}</span
            ></span
          >
        </div>
        <div class="supermarket-address" @click="phonepupshow = true">
          <span class="time-icon"><img :src="callserviceicon" alt="" /></span>
          <span class="supermarket-address-text">
            联系电话：<span
              v-show="merchantinfo.customer_service_tel"
              class="supermarket-address-text-phone"
            >
              {{ merchantinfo.customer_service_tel }}</span
            ></span
          >
        </div>
        <div class="supermarket-address" @click="getMap()">
          <span class="position-icon"><img :src="positionicon" alt="" /></span>
          <span class="supermarket-address-text">
            <span class="supermarket-address-text-title">地址：</span>
            <span class="supermarket-address-text-text"
              >{{
                merchantinfo.area_name | loadingStatus(merchantinfo.area_name)
              }}{{ merchantinfo.address }}{{merchantinfo.house_number}}
              <span class="position-icon"
                ><img :src="rightarrowicon" alt="" />
              </span>
            </span>
          </span>
        </div>
        <!-- <div class="supermarket-phone">
            <img :src="blackphoneicon" alt="" @click="phonepupshow = true" />
          </div> -->
      </div>
    </div>
    <div class="merchant-div">
      <div class="merchant-div-body">
        <div v-if="merchantinfo.top_o2o_category">
          <div class="title-text">经营品类</div>
          <div class="title-tip-text">
            商家经营品类：{{
              merchantinfo.top_o2o_category
                ? merchantinfo.top_o2o_category.name
                : ""
            }}{{
              merchantinfo.second_o2o_category
                ? "/" + merchantinfo.second_o2o_category.name
                : ""
            }}{{
              merchantinfo.third_o2o_category
                ? "/" + merchantinfo.third_o2o_category.name
                : ""
            }}
          </div>
        </div>
        <div
          v-if="
            merchantinfo.shop_environment_image &&
            merchantinfo.shop_environment_image.length
          "
        >
          <div class="title-text">店内环境图</div>
          <div class="merchant-img">
            <div
              class="merchant-img-item"
              v-for="(item, index) in merchantinfo.shop_environment_image"
              :key="index"
              @click="goodsImagePreview(index)"
            >
              <img :src="item.url" alt="" />
            </div>
          </div>
        </div>
        <div class="merchant-bottom-div" @click="gosupermarketQualifications">
          <div class="title-text">查看营业资质</div>
          <img class="merchant-right-icon" :src="rightarrowicon" alt="" />
        </div>
      </div>
      <div class="merchant-btn">
        <div
          class="merchant-bottom-btn merchant-bottom-btns"
          @click.stop="cardrecharge"
          v-if="merchantinfo.allow_recharge_on_line==1"
        >
          卡包充值
        </div>
        <div v-if="merchantinfo.allow_recharge_on_line!=null" class="merchant-bottom-btn" :style="merchantinfo.allow_recharge_on_line!=1?'width:94%;':''" @click.stop="cardchargeoff">卡包核销</div>
      </div>
    </div>
    <common-pup
      :pupshow="phonepupshow"
      :pup_content="
        merchantinfo.customer_service_tel
          ? merchantinfo.customer_service_tel
          : ''
      "
      @pupcancel="pupcancel"
      @pupcertain="pupcertain"
    />
    <imagePreview
      :images="images"
      :previewstartPosition="previewstartPositionindex"
      :previewshow="previewshow"
      @closepreview="closepreview"
    />
    <van-popup round
        v-model="foldshow"
        closeable
        position="bottom"
        :style="{ height: '30%' }"
        >
        <div class="fold_title">{{merchantinfo.shop_name}}</div>
        <div class="fold_remark">
            <p>店铺描述：</p>
            {{merchantinfo.intro}}
            </div>
        </van-popup>
  </div>
</template>

<script>
import commonPup from "./components/common-pup.vue";
import imagePreview from "./components/image-preview";
export default {
    components: {
    commonPup,
    imagePreview,
  },
  data() {
    return {
      positionicon: require("@/assets/shared-hotel/blackposition.png"), //位置图标
      blacktimeicon: require("@/assets/shared-hotel/blacktime.png"), //黑色时间图标
      blackphoneicon: require("@/assets/shared-hotel/blackphone.png"), //黑色电话图标
      callserviceicon: require("@/assets/shared-hotel/call_service.png"), //练习电话的图标
      backicon: require("@/assets/shared-hotel/leftBack.png"), //浅黑色返回图标
      rightarrowicon: require("@/assets/shared-hotel/rightarrow-icon.png"), //向右箭头
      scrollopacityStyle: "background: rgba(255, 255, 255,0)", //默认的透明度
      merchantinfo: {}, //商家基本信息
      phonepupshow: false, //是否显示手机呼叫弹出框
      foldshow:false,
      foldtop:require("@/assets/shared-hotel/fold_tops.png"),
      foldbottom:require("@/assets/shared-hotel/fold_bottoms.png"),
      images: [],
      previewshow:false,
      previewstartPositionindex: 0,
      client:0,
    };
  },
  filters: {
    loadingStatus(val) {
      if (!val) {
        return "加载中...";
      } else {
        return val;
      }
    },
  },
    created() {
         if (this.$route.query.token) {
            this.$api.setToken(this.$route.query.token);
            }
      let params = {
        lng: this.$route.query.lng,
        lat: this.$route.query.lat,
        id: this.$route.query.id,
      };
      this.$api.get("/offshop/index/shop/detail/get/shop/detail", params).then((res) => {
        this.merchantinfo = res
        for (let i in res.shop_environment_image) {
          this.images.push(res.shop_environment_image[i].url);
        }
      });
      this.deductionUA();
    },
    methods: {
      //地图导航
      getMap() {
        let param = {
          lon: this.merchantinfo.longitude,
          lat: this.merchantinfo.latitude,
          address: this.merchantinfo.address,
        };
        this.params(JSON.stringify(param), JSON.stringify(param), "getMap");
      },
       // 弹窗取消功能
        pupcancel() {
            this.phonepupshow = false;
        },
        deductionUA() {
            let ua = navigator.userAgent.toLowerCase();
            if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
            this.client = 11
            } else if (/android/.test(ua)) {
            this.client = 10
            }
        },
        // 弹窗确定功能
        pupcertain() {
            this.phonepupshow = false;
            if (this.merchantinfo.customer_service_tel){
                if(this.client==10){
                    this.params(this.merchantinfo.customer_service_tel, this.merchantinfo.customer_service_tel, "phone");
                }else{
                    window.location.href = `tel://${this.merchantinfo.customer_service_tel}`;
                }
            }
        },
      //返回事件
      goback() {
        if (this.$route.query.form) {
          //判断是否从原生的收藏跳转过来的
          this.params("home", "home", "goBack");
        } else {
            if(this.$route.query.entrance){//支付结果页的返回
                this.$router.push({
                    path: "/sharedHotel/store",
                    query: {
                        token:localStorage.getItem('_token'),
                        longitude: localStorage.getItem('longitude'),
                        latitude:localStorage.getItem('latitude'),
                        from:'h5'
                    },
                });
            }else{
                this.$router.go(-1);
            }
        }
      },
      //前往营业资质页面
      gosupermarketQualifications() {
          this.$router.push({
            path: "/sharedHotel/sharedCertificate",
            query: {
            id: this.$route.query.id,
            },
        });
          console.log(this.merchantinfo.certificates,"/sharedHotel/sharedCertificate");
      },
      //跳转卡包充值
      cardrecharge() {
        this.$router.push({
            path: "/sharedHotel/cardRecharge",
            query: {
              id: this.merchantinfo.id,
            },
        });
      },
      // 跳转卡包核销
      cardchargeoff(){
          this.$router.push({
              path:"/sharedHotel/immediatelyPay",
              query:{
                  id:this.merchantinfo.id,
                  shopname:this.merchantinfo.shop_name,
                  shoplogo:this.merchantinfo.logo
              }
          })
      },
      //显示预览图片
        goodsImagePreview(index) {
        this.previewshow = true;
        this.previewstartPositionindex = index;
        },
        //关闭图片预览组件
        closepreview() {
        this.previewshow = false;
        },
    },
};
</script>

<style lang="less" scoped>
.fold_title{
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    margin: 12px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}
.fold_remark{
    padding: 0 20px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    p{
        font-weight: 600;
        color: #333333;
        margin-bottom: 6px;
    }
}
.notdetail-body {
  background: #f5f6f7;
  height: 100%;
}
.goods-price {
  max-width: 100px;
  position: absolute;
  bottom: 3px;

  .goods-price-now {
    max-width: 46px;
    height: 22px;
    font-size: 12px;
    font-weight: 400;
    color: #f9591b;
    line-height: 17px;
    margin-right: 5px;
    word-break: normal;
    display: inline-block;

    .goods-price-nowbig {
      font-size: 15px;
      font-weight: 600;
    }
  }
  .goods_price {
    height: auto !important;
    line-height: normal !important;
  }
  .goods-price-old {
    text-decoration: line-through;
    width: 33px;
    height: 14px;
    font-size: 10px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    position: relative;
  }
}
.detail-body {
  position: relative;
}

.van-search {
  padding: 0 !important;
  margin: 0 !important;
  background-color: #fff;
  border-radius: 50% !important;
  height: 32px !important;
}

.fixed-title {
  position: fixed;
  top: 0;
  padding-top: 44px;
  width: 100%;
  z-index: 20;
}

.top-bg-img {
  position: absolute;
  width: 100%;
  height: 156px;
  z-index: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );

  // opacity: 0.5;
  img {
    height: 156px;
    width: 100%;
    object-fit: cover;
  }
}
.top-bg-op {
  position: absolute;
  z-index: 99;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  height: 100%;
}
.supermark-datail-info-div {
  position: relative;
  top: 98px;
  margin: 0 auto 0;
  width: 351px;
  box-shadow: 1px 3px 11px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  z-index: 10;
  background-color: #fff;
  display: flex;
  padding: 5px 0 15px 0;
  box-sizing: border-box;

  .supermarket-img {
    width: 50px;
    height: 50px;
    padding: 10px;

    img {
      border-radius: 6px;
      width: 50px;
      height: 50px;
    }
  }

  .supermarket-info {
    flex: 1;

    .supermarket-name {
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      padding-top: 10px;
    }
    .supermarket-remark{
        margin-top: 6px;
        width:252px;
        font-size: 14px;
        font-weight: 400;
        color: #979797;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .supermarket-fold{
            position: absolute;
            top:0px;
            right:15px;
            width: 10px;
            height: 9px;
            img{
                width: 100%;
            }
        }
    .supermarket-address {
      padding-top: 5px;
      display: flex;
      //   width: 245px;
      width: 270px;
      margin-top: 15px;

      .position-icon,
      .time-icon {
        width: 13px;
        height: 14px;
        display: inline-block;
        margin-right: 4px;
        position: relative;
        top: 3px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .time-icon {
        margin-right: 3px;
        width: 13px;
        height: 14px;
        top: 2px;
      }

      .supermarket-address-text {
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        display: flex;
        .supermarket-address-text-phone {
          color: #f54629;
        }
        .supermarket-address-text-title {
          flex: 1;
        }

        .supermarket-address-text-text {
          width: 210px;
        }
      }
    }

    .supermarket-phone {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      width: 15px;
      height: 15px;

      img {
        width: 15px;
        height: 15px;
      }
    }
  }
}

.back-btn-img {
  display: inline-block;
  padding-left: 9px;
  position: relative;
  top: 7px;

  img {
    height: 24px;
    width: 24px;
  }
}

.top-search-div {
  display: inline-block;
  width: calc(100% - 174px);
  padding-top: 6px;
  padding-bottom: 6px;
  position: relative;
  input {
    height: 32px;
    width: calc(100% - 5px);
    border-radius: 20px;
    outline: none;
    border: none;
    text-indent: 38px;
    font-size: 14px;
  }
  img {
    vertical-align: middle;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 14px;
    margin-top: 9px;
  }
}

.top-right {
  display: inline-block;
  width: 134px;
  // position: relative;
  // top: -2px;
  vertical-align: top;
  height: 48px;
  line-height: 48px;

  .redheart {
    width: 20px;
    height: 20px;
    margin: 0 5px 0 20px;
    position: relative;
    top: 5px;

    img {
      width: 20px;
      height: 20px;
    }
  }
  .attention-text,
  .full-attention-text {
    min-width: 45px;
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    display: inline-block;
    text-align: center;
  }

  .full-attention-text {
    min-width: 50px;
    color: #333333;
  }

  .point-img {
    width: 23px;
    height: 5px;
    // position: relative;
    position: absolute;
    // top: -2px;
    // left: 12px;
    right: 12px;

    img {
      width: 23px;
      height: 5px;
    }

    .notification-div {
      position: absolute;
      // top: 29px;
      right: 0;
      width: 121px;
      height: 65px;
      background: #000000;
      opacity: 0.8;
      border-radius: 5px;
      line-height: 65px;
      .notification-item {
        .notification-img {
          width: 15px;
          height: 15px;
          display: inline-block;

          img {
            width: 15px;
            height: 15px;
            position: relative;
            top: 3px;
            left: 20px;
          }
        }

        .notification-text {
          display: inline-block;
          // width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          padding-left: 29px;
        }
      }
    }
    .notification-div::before {
      width: 0;
      height: 0;
      content: "";
      position: absolute;
      right: 10px;
      top: -6px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 7px solid #000000cc;
    }
  }
}

.choose-div {
  padding: 0 0 18px 12px;
  position: sticky;
  top: 108px;
  margin-top: 120px;

  .choose-btn,
  .choose-btn-activate {
    width: 64px;
    height: 22px;
    font-size: 16px;
    line-height: 22px;
  }

  .choose-btn-activate {
    font-weight: 600;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      bottom: -7px;
      left: 19px;
      width: 22px;
      height: 3px;
      background: #f9591b;
      border-radius: 2px;
    }
  }
  .merchant-btn-activate {
    width: 32px;
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      bottom: -7px;
      left: 5px;
      width: 22px;
      height: 3px;
      background: #f9591b;
      border-radius: 2px;
    }
  }

  .choose-btn:nth-child(2) {
    margin-left: 30px;
  }
}

.all-goods-div {
  position: sticky;
  top: 180px;
  z-index: 20;
}

.goods-div {
  display: flex;
  // height: calc(100vh - 254px);
  // height: calc(100vh - 178px); //适配小屏幕
  height: calc(100vh - 146px);

  // height: calc(100vh - 154px);
  // width: 86px;
  .goods-left-body {
    width: 86px;
    background: #f5f5f5;
    padding-bottom: 50px;

    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    &::-webkit-scrollbar {
      display: none;
      /* Chrome Safari */
    }

    .left-tag,
    .left-tag-activate {
      width: 52px;
      overflow: hidden;
      padding: 14px 26px 14px 12px;
      background: #f5f5f5;
      min-height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
      overflow-wrap: break-word;
      text-align: center;
    }

    .left-tag-activate {
      position: relative;
      background: #ffffff;
      font-weight: 600;
      color: #333333;

      &:before {
        content: "";
        width: 3px;
        height: 20px;
        background: #f9591b;
        border-radius: 0px 2px 2px 0px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
      }
    }

    .left-tag-top {
      border-radius: 0 0 6px 0;
    }

    .left-tag-bottom {
      border-radius: 0 6px 0 0;
    }
  }

  .goods-left-body-isiox {
    padding-bottom: 84px;
  }

  .goods-right-body {
    flex: 1;
    margin-left: 9px;
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    &::-webkit-scrollbar {
      display: none;
      /* Chrome Safari */
    }

    .goods-item {
      padding-top: 30px;
      padding-bottom: 50px;

      .goods-item-twomenu {
        position: absolute;
        width: 268px;
        top: -1px;
        background-color: #ffffff;
        z-index: 5;
        margin-right: 12px;
        padding-bottom: 2px;

        .goods-right-top-tag {
          width: 238px;
          white-space: nowrap;
          overflow-x: scroll;
          scrollbar-width: none;
          /* firefox */
          -ms-overflow-style: none;
          /* IE 10+ */
          &::-webkit-scrollbar {
            display: none;
            /* Chrome Safari */
          }
        }
        .whole-second-nav {
          width: 30px;
          height: 30px;
          position: absolute;
          right: 0;
          top: 0;
          line-height: 30px;
          font-weight: 400;
          font-size: 9px;
          color: #666666;
          text-align: center;
          background-color: #ffffff;
          box-shadow: -2px 0px 1px 0px rgba(0, 0, 0, 0.07);

          img {
            position: absolute;
            width: 10px;
            height: 9px;
            bottom: 3px;
            right: 10px;
          }
        }
      }

      .twomenu-mask {
        position: absolute;
        width: 280px;
        background: #000000;
        max-height: calc(100vh - 200px);
        opacity: 0.6;
        height: 100%;
        z-index: 3;
      }

      .goods-item-open-twomenu {
        position: absolute;
        top: -0.02666667rem;
        background-color: #ffffff;
        z-index: 666666;
        padding-bottom: 9px;
        width: calc(100% - 95px);

        .twomenu-top {
          display: inline-block;

          .twomenu-top-left-text {
            height: 17px;
            font-size: 12px;
            font-weight: 600;
            color: #333333;
            line-height: 17px;
            padding-bottom: 15px;
          }

          .close-second-nav {
            width: 10px;
            height: 10px;
            position: absolute;
            right: 12px;
            top: 0;
            line-height: 30px;
            font-weight: 400;
            font-size: 9px;
            color: #666666;
            text-align: center;
            background-color: #ffffff;

            img {
              position: absolute;
              width: 10px;
              height: 9px;
              bottom: 0;
              right: 10px;
            }
          }
        }

        .goods-right-top-tag {
          overflow: hidden;
          white-space: break-spaces;

          .goods-right-body-toptag:nth-child(n + 4),
          .goods-right-body-toptag-activate:nth-child(n + 4) {
            margin-top: 5px;
          }
        }
      }

      .goods-right-body-toptag-title {
        position: sticky;
        top: 29px;
        z-index: 2;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
        padding: 15px 0;
        background-color: #ffffff;
      }

      .goods-right-body-toptag,
      .goods-right-body-toptag-activate {
        width: 86px;
        height: 30px;
        border-radius: 2px;
        background: #f5f5f5;
        text-align: center;
        line-height: 30px;
        display: inline-block;
        margin-left: 5px;

        span {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
        }
      }

      .goods-right-body-toptag:nth-child(1),
      .goods-right-body-toptag-activate:nth-child(1) {
        margin: 0;
      }

      .goods-right-body-toptag-activate {
        background: #ffede6;

        span {
          color: #f9591b;
        }
      }
      .goods-item-div {
        position: relative;
        margin: 0 12px 0 0px;
        padding: 14px 0 15px 0;
        border-top: 1px solid rgba(238, 238, 238, 1);
        .goods-food-item {
          display: flex;
          margin: 0 12px 0 0px;
          padding: 0px 0 0px 0;

          &:last-child {
            border-bottom: 0px solid;
          }

          .food-img {
            width: 80px;
            height: 80px;
            position: relative;

            img {
              border-radius: 6px;
              width: 80px;
              height: 80px;
            }
            .food-soldout-img {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
            }
          }

          .food-info-div {
            flex: 1;
            margin-left: 10px;
            position: relative;

            .goods-name {
              min-height: 20px;
              font-size: 14px;
              font-weight: 600;
              color: #333333;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              width: auto;
              /* height: 32px; */
              word-break: break-all;
            }

            .goods-content {
              // height: 60px;
            }

            .goods-info-text {
              padding: 5px 0 0 0;
              height: 16px;
              font-size: 11px;
              font-weight: 400;
              color: #999999;
              line-height: 16px;

              span {
                margin-left: 10px;
              }

              span:nth-child(1) {
                margin-left: 0;
              }
            }
          }
          .chosse-specification-btn {
            position: absolute;
            right: 0px;
            bottom: 2px;
            height: 16px;
            background: #f9591b;
            border-radius: 20px;
            color: #ffffff;
            font-size: 12px;
            line-height: 17px;
            padding: 6px 10px;
            text-align: center;
            box-shadow: 0 4px 3px -3px #f9591b;
          }
          .purchase {
            padding: 5px 17px;
          }
          .chosse-food-btn {
            position: absolute;
            // bottom: -4px;
            right: 0;
          }
          .goods-food-item:first-child {
            padding-top: 0;
          }
        }
      }
      .goods-item-div:last-child {
        padding-bottom: 0;
      }
    }
  }
}

// 选择按钮样式
.chosse-add-btn,
.chosse-minus-btn {
  width: 33px;
  height: 33px;
  padding-bottom: 7px;
  background: transparent;

  img {
    width: 100%;
    height: 100%;
  }
}

.chosse-minus-btn {
  width: 22px;
  height: 22px;
  padding: 5px 0 0 0;
}

.cartgoodsnum-div {
  height: 18px;
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  padding: 8px 2px 0 7px;
}

.merchant-div {
  margin: 111px 12px 12px 12px;
  background: #ffffff;
  border-radius: 6px;
  .merchant-div-body {
    padding: 12px 12px;
    box-sizing: border-box;
    .title-text {
      height: 18px;
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      line-height: 18px;
      padding-bottom: 10px;
      display: inline-block;
    }

    .merchant-bottom-div {
      height: 18px;
      line-height: 18px;
    }

    .merchant-right-icon {
      float: right;
      width: 18px;
      height: 18px;

      img {
        width: 100%;
      }
    }

    .title-tip-text {
      min-height: 18px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding-bottom: 20px;
    }

    .merchant-img {
      padding-bottom: 20px;
      height: 90px;
      white-space: nowrap;
      width: calc(100%);
      overflow-x: scroll;
      overflow-y: hidden;

      .merchant-img-item {
        width: 90px;
        height: 90px;
        padding-right: 10px;
        display: inline-block;
        // background: #d8d8d8;
        border-radius: 3px;
        overflow: hidden;
        img {
          width: 90px;
          height: 90px;
          object-fit: cover;
        }

        &:nth-last-child(1) {
          padding-right: 0;
        }
      }
    }
  }

  .merchant-btn {
    position: fixed;
    bottom: 50px;
    left: 0;
    right: 0;
    text-align: center;
    // margin-top: 40px;
    .merchant-bottom-btn {
      display: inline-block;
      //   width: 180px;
      //   height: 29px;
      background: linear-gradient(270deg, #f41a3c 0%, #fc740c 100%);
      //   margin: auto;
      border-radius: 60px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      //   line-height: 29px;
      padding: 10px 42px;
      box-sizing: border-box;
      text-align: center;
    }
    .merchant-bottom-btns {
      background: #f5f5f5;
      color: #f9591b;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(135deg, #f5f5f5, #f5f5f5),
        linear-gradient(135deg, #fc740c, #f41a3c);
      border: 1px transparent solid;
    }
    .merchant-bottom-btn + .merchant-bottom-btn {
      margin-left: 10px;
    }
  }
}

.nofind {
  padding: 0 34px;
}

.shopcar-detail-div {
  padding: 0 12px;
  height: 100%;

  .shopcar-detail-one-div {
    width: 100%;
    height: 21px;
    font-size: 15px;
    font-weight: 600;
    color: #333333;
    line-height: 21px;
    padding: 20px 12px;
    box-sizing: border-box;
    background-color: #fff;

    .one-div-float {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      float: right;
    }
  }

  .shop-car-food-div {
    height: calc(100% - 99px);
    overflow: hidden;
    overflow-y: scroll;
  }
}

//购物车详情，选规格通用样式
.shopcar-detail-two-div {
  display: flex;

  .two-one-img {
    width: 66px;
    height: 66px;
    margin-right: 10px;
    background: #d8d8d8;
    border-radius: 6px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .two-two-div {
    width: calc(100% - 100px);

    .two-two-div-title {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
      margin-bottom: 30px;
    }

    .two-two-div-text {
      .goods-price-now {
        max-width: 46px;
        height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #f9591b;
        line-height: 17px;
        margin-right: 5px;

        .goods-price-nowbig {
          font-size: 15px;
          font-weight: 600;
        }
      }

      .goods-price-old {
        text-decoration: line-through;
        width: 33px;
        height: 14px;
        font-size: 10px;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        position: relative;
      }
    }
  }

  .two-two-div-text {
    .two-two-now-dollar,
    .two-two-now-price {
      height: 22px;
      font-size: 12px;
      font-weight: 400;
      color: #f9591b;
      line-height: 17px;
    }

    .two-two-now-price {
      font-size: 18px;
      margin-right: 2px;
    }

    .two-two-old-price {
      text-decoration: line-through;
      height: 14px;
      font-size: 10px;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
    }
  }

  .two-three-btn {
    flex: 1;
    height: 33px;
    margin-top: 40px;
    text-align: right;

    .chosse-minus-btn,
    .cartgoodsnum-div,
    .chosse-add-btn {
      display: inline-block;
      vertical-align: top;
    }

    .chosse-minus-btn {
      padding: 0;
      position: relative;
      top: 5px;
    }
  }
}

//通用部分结束
.specification-detail-div {
  padding: 20px 12px;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;

  .two-two-div-title {
    margin-bottom: 4px !important;
  }

  .specification-two-div-text {
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
    margin-bottom: 5px;
  }

  .specification-detail-two-div {
    height: calc(100% - 103px);
    overflow-y: scroll;

    .specification-detail-item {
      &:last-child {
        margin-bottom: 10px;
      }

      .specification-detail-item-title {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        margin: 20px 0 10px 0;
      }

      .specification-detail-item-tag-div {
        .specification-detail-item-tag,
        .specification-detail-item-tag-active {
          margin: 10px 10px 0 0;
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          display: inline-block;
          padding: 9px 0 8px 0;
          width: calc((100% - 20px) / 3);
          text-align: center;
          color: #666666;
          background: #f5f6f7;
          border-radius: 2px;

          &:nth-child(3n + 0) {
            margin-right: 0px;
          }
        }

        .specification-detail-item-tag-active {
          background: #ffede6;
          color: #f9591b;
        }
      }
    }
  }

  .specification-detail-btn {
    width: 351px;
    height: 50px;
    background: linear-gradient(270deg, #f41a3c 0%, #fc740c 100%);
    border-radius: 60px;
    padding: 10px 0;
    height: 29px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 29px;
    text-align: center;
    margin-bottom: 8px;
  }
}
.take_reset_body {
  border-radius: 6px;
}
.take_reset {
  padding: 0.8rem 0;
  font-size: 0.42666667rem;
  color: #333;
  font-weight: 600;
  width: 270px;
  text-align: center;
}
.take_reset_bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #333;
  font-size: 16px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  //   padding-bottom: 35px;
  padding-bottom: 65px;
  z-index: 999;
  font-weight: 600;
}
.van-list {
  padding-bottom: 50px;
}
.car-ball {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: red;
  position: fixed;
  z-index: 4000;
  top: 10;
}
</style>
